import * as React from 'react';

import { connect } from 'react-redux';
import { VegnettQueries } from '@/middleware/queries';
import * as selectors from '../../../selectors/selectors';
import { RootState, VegnettRetning } from '@/state';
import SimpleToggle from '../../objects/SimpleToggle';
import { VegnettFilter } from './VegnettFilter';
import {
    resetRoadNetFilter,
    setRoadNetFilter,
    toggleRoadNetVisibility,
} from '@/actions/vegnettActions';
import { DownloadResultsBox } from './DownloadResultsBox';
import { VegnettLegend } from './VegnettLegend';

interface StateProps {
    roadNetDirection: VegnettRetning;
    roadNetFilter: VegnettQueries;
    roadNetLoading: boolean;
    roadNetProgress: number;
    roadNetVisible: boolean;
}

interface DispatchProps {
    doToggleRoadNetVisibility: () => void;
    doResetRoadNetFilter: () => void;
    doSetRoadNetFilter: (newFilter: VegnettQueries) => void;
}

type Props = StateProps & DispatchProps;
interface OwnState {
    open: boolean;
    showProgressBar: boolean;
}

const mapStateToProps = (state: RootState) => {
    return {
        roadNetDirection: selectors.stateVegnettDirection(state),
        roadNetFilter: selectors.stateVegnettFilter(state),
        roadNetLoading: selectors.stateVegnettLoading(state),
        roadNetProgress: selectors.stateVegnettProgress(state),
        roadNetVisible: selectors.stateVegnettVisible(state),
    };
};

const mapDispatchToProps = {
    doResetRoadNetFilter: resetRoadNetFilter,
    doSetRoadNetFilter: setRoadNetFilter,
    doToggleRoadNetVisibility: toggleRoadNetVisibility,
};

class RoadNetComponent extends React.Component<Props, OwnState> {
    readonly state = { open: false, showProgressBar: false };

    componentDidUpdate(prevProps: Props) {
        if (!prevProps.roadNetLoading && this.props.roadNetLoading) {
            this.setState({ showProgressBar: true });
        }

        if (
            prevProps.roadNetProgress !== this.props.roadNetProgress &&
            this.props.roadNetProgress === 100
        ) {
            setTimeout(() => {
                this.setState({ showProgressBar: false });
            }, 600);
        }
    }

    handleToggleRoadnet() {
        this.props.doToggleRoadNetVisibility();
    }

    handleResetFilter() {
        this.props.doResetRoadNetFilter();
    }

    render() {
        const {
            roadNetDirection,
            roadNetVisible,
            roadNetFilter,
            roadNetLoading,
            roadNetProgress,
        } = this.props;
        const { open, showProgressBar } = this.state;
        const openStateClassModifier = open ? 'open' : 'closed';

        return (
            <div className="c-road-net t-hidden-mobile">
                <section className="c-road-net__header">
                    <button
                        className="c-road-net__filter-button"
                        onClick={() => {
                            this.setState({ open: !open });
                        }}
                        id="choose-roadnet"
                        aria-expanded={open}
                    >
                        <i
                            className={`o-icon-chevron-right
                                       c-road-net__chevron c-road-net__chevron--${openStateClassModifier}`}
                        />
                        <span className="c-road-net__chevron-text">Velg vegnett</span>
                    </button>
                    <SimpleToggle
                        className="c-road-net__toggle-switch"
                        checked={roadNetVisible}
                        label="Vis i kart"
                        id="show_roadnet_toggle"
                        onChange={() => this.handleToggleRoadnet()}
                    />
                    {roadNetVisible && <VegnettLegend />}
                    {(roadNetLoading || showProgressBar) && (
                        <progress
                            className="c-road-net__progress-bar"
                            value={roadNetProgress}
                            max={100}
                            aria-label="Road net progress"
                        ></progress>
                    )}
                    <button
                        className="c-road-net__nullify"
                        disabled={roadNetFilter.isEmpty() || roadNetFilter.isFull()}
                        onClick={e => {
                            e.stopPropagation();
                            this.handleResetFilter();
                        }}
                    >
                        Nullstill filter
                    </button>
                </section>
                {open && (
                    <>
                        <VegnettFilter
                            vegnettfilter={roadNetFilter}
                            vegnettRetning={roadNetDirection}
                            setVegnettfilter={this.props.doSetRoadNetFilter}
                        />
                        <DownloadResultsBox />
                    </>
                )}
            </div>
        );
    }
}

export const Vegnett = connect<
    StateProps,
    DispatchProps,
    Record<string, never>,
    RootState
>(
    mapStateToProps,
    mapDispatchToProps
)(RoadNetComponent);
